
<script setup>
import { ref } from "vue";
import { onMounted, defineProps } from "vue";
import { computed } from "vue";

const props = defineProps({
  showAssigned: {
    type: Boolean,
    default: true,
  },
  item: {
    type: [Object, Number],
    default: null,
  },
  showCategories: {
    type: Boolean,
    default: true,
  }
});

const percentage = ref(0);
const showAssignedToYou = ref(Math.random() < 0.5);
const numberCategories = ref(Math.floor(Math.random() * 5) + 1);
const showAssigned = computed(() => props.showAssigned);

onMounted(() => {
  setInterval(() => {
    percentage.value = (percentage.value % 100) + 10;
  }, Math.random() * 1000 + 500);
});
</script>
<template>
  <li
    class="col-span-1 shadow-lg rounded-md px-3 py-4 relative border border-untitled-gray-200 overflow-hidden bg-untitled-gray-25"
  >
    <div class="w-full flex flex-col">
      <!-- course title -->
      <div
        class="w-full p-2 rounded-md mt-2 bg-untitled-gray-300 animate-pulse"
        v-if="!item?.title"
      ></div>
      <div
        class="py-1.5 flex justify-start items-center font-semibold text-untitled-gray-600"
        v-if="item?.title"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="w-full flex flex-col lg:flex-row pt-3">
      <div
        class="min-w-48 min-h-40 max-w-48 rounded-lg bg-untitled-gray-300 overflow-hidden"
      >
        <img
          v-if="item && item.thumbnail"
          v-lazy="{
            src: item.thumbnail,
            error:
              'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
            loading:
              'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
          }"
          alt=""
          class="w-full h-full object-cover"
        />
      </div>
      <div class="flex-1 flex flex-col justify-between pt-3 sm:pt-0">
        <div
          class="w-full flex flex-row flex-wrap gap-3 lg:px-3 px-2 justify-start items-start"
        >
          <div
            class="flex-1 max-h-8 sm:min-w-24 lg:min-w-28 flex gap-2 text-xs font-medium justify-start items-center bg-untitled-gray-300 w-full p-2 rounded-md"
            v-for="n in 4"
            :key="n"
          ></div>
        </div>
        <div
          class="flex-1 flex justify-center items-center w-full px-2 lg:px-3"
        >
          <div
            class="w-full h-2 bg-untitled-gray-100 flex justify-start items-center"
          >
            <div class="w-3/5 bg-untitled-gray-300 h-2 rounded-md flex-1"></div>
          </div>
        </div>
        <div class="w-full flex justify-end items-end gap-2">
          <div class="w-28 p-3 bg-untitled-gray-300 rounded-md"></div>
          <div class="w-28 p-3 bg-untitled-gray-300 rounded-md"></div>
        </div>
      </div>
    </div>
    <div
      class="w-full border-t border-untitled-gray-300 pt-2 mt-3 flex flex-row gap-3 justify-start items-center overflow-hidden"
      v-if="showCategories"
    >
      <div
        class="p-2 rounded-lg bg-untitled-gray-300 animate-pulse w-16"
        v-for="n in numberCategories"
        :key="n"
      ></div>
    </div>
    <div
      class="absolute text-xs top-0 left-0 py-2.5 w-32 flex justify-center items-center px-3 font-semibold bg-untitled-gray-300 text-untitled-gray-25 rounded-br-md"
      v-if="showAssignedToYou && showAssigned"
    ></div>
  </li>
</template>

<style lang="scss" scoped></style>
